<div class="modal" id="revokeStateDataPopupOm" tabindex="-1">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">
                    {{popupHeaderTexts.enableUsers}}
                </h5>
            </div>
            <div class="modal-body">
                <app-enabled-customer-users [fromComponent]="fromComponent" [sectionName]="sectionName"
                    [tableConfigOptions]="enabledCustUsersTableConfigOptions"
                    [rowData]="usersData"></app-enabled-customer-users>

            </div>
            <div class="modal-footer">
                <button type="button" id="{{createIdString()}}-closeBtn" class="btn btn-sm btn-secondary"
                    (click)="closeRevokeStateDataPopup()">Close</button>
            </div>
        </div>
    </div>
</div>